export default {
    // GENERAL
    /**
     * @param {Object} state vuex builder module state
     * @param {Formula} formula
     */
    setFormula(state, formula) {
        state.formula = formula.toObject()
    },

    setAudienceInEditionId(state, value) {
        state.audienceInEditionId = value
    },

    // BREAKDOWN
    /**
     * @param {Object} state vuex builder module state
     * @param {Boolean} loading
     */
    setBuilderFormulaBreakdownLoading(state, loading) {
        state.formulaBreakdownLoading = loading
    },

    /**
     * @param {Object} state vuex builder module state
     * @param {Object} payload
     * @param {Object[]} payload.children
     * @param {Object} payload.volume
     */
    setBuilderFormulaBreakdown(state, breakdown) {
        state.formulaBreakdown = breakdown
    },

    // RESUME
    /**
     * @param {Object} state vuex builder module state
     * @param {Boolean} loading
     */
    setBuilderFormulaSummaryLoading(state, loading) {
        state.formulaSummaryLoading = loading
    },

    /**
     * @param {Object} state vuex builder module state
     * @param {Object} payload
     * @param {Object[]} payload.children
     * @param {Object} payload.volume
     */
    setBuilderFormulaSummary(state, resume) {
        state.formulaSummary = resume
    },

    // VOLUMES
    /**
     * @param {Object} state vuex builder module state
     * @param {Boolean} loading
     */
    setBuilderFormulaVolumesLoading(state, loading) {
        state.formulaVolumesLoading = loading
    },

    /**
     * @param {Object} state vuex builder module state
     * @param {Object} payload
     * @param {Object} payload.formula
     */
    setBuilderFormulaVolumes(state, { formula }) {
        state.formulaVolumes = formula.children
        state.formulaGlobalVolume = formula.volume
    },

    /**
     * @param {Object} state vuex builder module state
     * @param {String} volumeType 'ID based' or 'Cross device'
     */
    setFormulaVolumeType(state, volumeType) {
        state.formulaVolumeType = volumeType
    },

    resetFormula(state, value) {
        state.resetFormula = value
    }
}
